module.exports = __webpack_public_path__ + "img/SZ.6d8555f1.png";